import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EstimateComopnent } from '../estimate.component';
import { ComponentOptions } from '../../models/component-option';

@Component({
  selector: 'part-estimate',
  templateUrl: './part-estimate.component.html'
})
export class PartEstimateComponent extends EstimateComopnent {
  @Input({ required: true }) index: number;
  @Output() remove = new EventEmitter<void>();

  public selectedPartComponent: ComponentOptions;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      'partNumber': new UntypedFormControl("", [Validators.required]),
      'etaDays': new UntypedFormControl("", [Validators.required]),
      'price': new UntypedFormControl("", [Validators.required]),
      'quantity': new UntypedFormControl("", [Validators.required]),
      'isOem': new UntypedFormControl(false),
      'description': new UntypedFormControl(""),
    });
  }

  public override get total(): number {
    return (this.form.get('price').value ?? 0) * (this.form.get('quantity').value ?? 0);
  }

  public onSelectedComponent(componentOptions: ComponentOptions): void {
    this.selectedPartComponent = componentOptions;
  }

  public removePart(): void {
    this.remove.emit();
  }
}
